mtl.alloy.factory['history-back'] = (function($) {
    'use strict';

    return function(element, options) {
        $(element).on('click', function(e){
            e.preventDefault();

            window.history.back();
        });
    }

}($));
